module.exports = __webpack_public_path__ + "img/30e474b.svg";